import React from "react";
import Navigation from "../../navigation/Navigation";
import { Link } from "react-router-dom";

/**
 * This page presents the user with a form that is populated with 5 different buttons.
 * When a button is pressed it will then redirect the user to the corresponding page that is linked to that button.
 * @returns a form with 5 buttons
 */

function StudentHomepage() {

    return(
        <div className="studentHomepageContainer">
            <Navigation/>
            <form>
                <h1 style={{textAlign: "center"}}>Home Page</h1>
                <div className="buttonGrid paper">
                    <Link to="/createEditProject">
                        <button className="homeButton" type="button">
                            Create/Edit Own Project
                        </button>
                    </Link>
                    <Link to="/viewProjects">
                        <button className="homeButton" type="button">
                            Project Suggestions
                        </button>
                    </Link>
                    <Link to="/viewShortlist">
                        <button className="homeButton" type="button">
                            Project Shortlist
                        </button>
                    </Link>
                    <Link to="/makeChoices">
                        <button className="homeButton" type="button">
                            Make Choices
                        </button>
                    </Link>
                    <Link to="/viewFinalAllocation">
                        <button className="homeButton" type="button">
                            Final Project Allocation
                        </button>
                    </Link>
                </div>
            </form>
        </div>
    )
}

export default StudentHomepage